// Anonymized demo data for the Spotlight landing page preview
// Fictional team, agents, addresses, and reviews

export const DEMO_SPOTLIGHT_DATA = {
  settings: {
    headline: null,
    subheadline: null,
    cta_text: 'Get in Touch',
    cta_link: null,
    contact_email: 'hello@horizonrealtygroup.com',
    contact_phone: '(555) 867-5309',
    show_homes_carousel: true,
    show_sales_stats: true,
    show_team_section: true,
    show_views_saves: true,
    show_market_comparison: true,
    show_map: true,
    show_showings: true,
    show_reviews: true,
    show_speed_to_sold: true,
    zillow_sales_count_all_time: 1847,
    zillow_sales_count_last_year: 168,
    zillow_avg_value_three_year: 345200,
    zillow_price_range_min: 85000,
    zillow_price_range_max: 1450000,
    custom_primary_color: null,
    custom_secondary_color: null,
    social_facebook: null,
    social_instagram: null,
    social_linkedin: null,
    social_twitter: null,
    social_youtube: null,
    social_tiktok: null,
    review_summary: 'Clients consistently praise Horizon Realty Group for their responsiveness, deep market knowledge, and dedication to a seamless experience. Agents are noted for their patience, expert negotiation skills, and clear communication throughout every step of the buying or selling process.',
    zillow_total_reviews: 312,
    page_views_count: 0,
    custom_avg_dom: 28,
    hero_media_type: 'listing',
    hero_custom_url: null,
    hero_listing_north_id: 'demo-home-04',
  },
  team: {
    name: 'Horizon Realty Group',
    company_name: '',
    company_logo_url: '',
    default_primary_color: '#0c0f24',
    default_secondary_color: '#1b489b',
  },
  agents: [
    { name: 'Sarah Mitchell', headshot_url: null },
    { name: 'James Chen', headshot_url: null },
    { name: 'Maria Rodriguez', headshot_url: null },
    { name: 'David Park', headshot_url: null },
    { name: 'Emily Watson', headshot_url: null },
  ],
  homes: [
    {
      id: 'demo-home-01',
      zip: '43016',
      beds: 4,
      city: 'Riverside',
      sqft: 2450,
      baths: 3.0,
      price: 425000.0,
      state: 'OH',
      address: '1284 Maple Ridge Ln',
      image_url: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&h=600&fit=crop',
      saves_count: 142,
      views_count: 3820,
      portal_saves: 142,
      portal_views: 3820,
      report_saves: 98,
      report_views: 1450,
      days_on_zillow: 6,
      listing_status: 'For Sale',
      showings_count: 8,
      agent_photo_url: null,
      custom_agent_name: 'Sarah Mitchell',
    },
    {
      id: 'demo-home-02',
      zip: '43081',
      beds: 3,
      city: 'Lakeview',
      sqft: 1780,
      baths: 2.0,
      price: 315000.0,
      state: 'OH',
      address: '742 Birchwood Dr',
      image_url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop',
      saves_count: 98,
      views_count: 2940,
      portal_saves: 98,
      portal_views: 2940,
      report_saves: 72,
      report_views: 1200,
      days_on_zillow: 9,
      listing_status: 'For Sale',
      showings_count: 5,
      agent_photo_url: null,
      custom_agent_name: 'James Chen',
    },
    {
      id: 'demo-home-03',
      zip: '43065',
      beds: 3,
      city: 'Oakdale',
      sqft: 1560,
      baths: 2.0,
      price: 289900.0,
      state: 'OH',
      address: '3901 Sunset Terrace',
      image_url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=600&fit=crop',
      saves_count: 65,
      views_count: 1850,
      portal_saves: 65,
      portal_views: 1850,
      report_saves: 48,
      report_views: 980,
      days_on_zillow: 12,
      listing_status: 'For Sale',
      showings_count: 4,
      agent_photo_url: null,
      custom_agent_name: 'Maria Rodriguez',
    },
    {
      id: 'demo-home-04',
      zip: '43017',
      beds: 5,
      city: 'Summit Hills',
      sqft: 3200,
      baths: 4.0,
      price: 785000.0,
      state: 'OH',
      address: '890 Ridgecrest Blvd',
      image_url: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop',
      saves_count: 87,
      views_count: 2210,
      portal_saves: 87,
      portal_views: 2210,
      report_saves: 65,
      report_views: 1680,
      days_on_zillow: 11,
      listing_status: 'For Sale',
      showings_count: 6,
      agent_photo_url: null,
      custom_agent_name: 'David Park',
    },
    {
      id: 'demo-home-05',
      zip: '43230',
      beds: 4,
      city: 'Brookhaven',
      sqft: 2100,
      baths: 3.0,
      price: 549000.0,
      state: 'OH',
      address: '2156 Fieldstone Way',
      image_url: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&h=600&fit=crop',
      saves_count: 53,
      views_count: 1420,
      portal_saves: 53,
      portal_views: 1420,
      report_saves: 38,
      report_views: 980,
      days_on_zillow: 18,
      listing_status: 'For Sale',
      showings_count: 3,
      agent_photo_url: null,
      custom_agent_name: 'Emily Watson',
    },
    {
      id: 'demo-home-06',
      zip: '43016',
      beds: 3,
      city: 'Riverside',
      sqft: 1620,
      baths: 2.0,
      price: 275000.0,
      state: 'OH',
      address: '508 Creekside Ct',
      image_url: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=800&h=600&fit=crop',
      saves_count: 175,
      views_count: 3100,
      portal_saves: 175,
      portal_views: 3100,
      report_saves: 155,
      report_views: 2700,
      days_on_zillow: 7,
      listing_status: 'For Sale',
      showings_count: 10,
      agent_photo_url: null,
      custom_agent_name: 'Sarah Mitchell',
    },
    {
      id: 'demo-home-07',
      zip: '43082',
      beds: 2,
      city: 'Lakeview',
      sqft: 1050,
      baths: 2.0,
      price: 210000.0,
      state: 'OH',
      address: '1923 Harbor Pointe Rd',
      image_url: 'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=800&h=600&fit=crop',
      saves_count: 112,
      views_count: 1750,
      portal_saves: 112,
      portal_views: 1750,
      report_saves: 112,
      report_views: 1750,
      days_on_zillow: 14,
      listing_status: 'For Sale',
      showings_count: 7,
      agent_photo_url: null,
      custom_agent_name: 'James Chen',
    },
    {
      id: 'demo-home-08',
      zip: '43017',
      beds: 4,
      city: 'Summit Hills',
      sqft: 4200,
      baths: 5.0,
      price: 950000.0,
      state: 'OH',
      address: '6701 Pinnacle Dr',
      image_url: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800&h=600&fit=crop',
      saves_count: 45,
      views_count: 1180,
      portal_saves: 45,
      portal_views: 1180,
      report_saves: 40,
      report_views: 920,
      days_on_zillow: 32,
      listing_status: 'For Sale',
      showings_count: 2,
      agent_photo_url: null,
      custom_agent_name: 'David Park',
    },
    {
      id: 'demo-home-09',
      zip: '43065',
      beds: 3,
      city: 'Oakdale',
      sqft: 1850,
      baths: 2.0,
      price: 335000.0,
      state: 'OH',
      address: '4412 Willowbrook Ln',
      image_url: 'https://images.unsplash.com/photo-1600585153490-76fb20a32601?w=800&h=600&fit=crop',
      saves_count: 82,
      views_count: 1560,
      portal_saves: 82,
      portal_views: 1560,
      report_saves: 72,
      report_views: 1320,
      days_on_zillow: 21,
      listing_status: 'For Sale',
      showings_count: 5,
      agent_photo_url: null,
      custom_agent_name: 'Maria Rodriguez',
    },
    {
      id: 'demo-home-10',
      zip: '43230',
      beds: 4,
      city: 'Brookhaven',
      sqft: 1920,
      baths: 3.0,
      price: 399900.0,
      state: 'OH',
      address: '827 Thornberry Cir',
      image_url: 'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?w=800&h=600&fit=crop',
      saves_count: 68,
      views_count: 1340,
      portal_saves: 68,
      portal_views: 1340,
      report_saves: 62,
      report_views: 1180,
      days_on_zillow: 16,
      listing_status: 'For Sale',
      showings_count: 4,
      agent_photo_url: null,
      custom_agent_name: 'Emily Watson',
    },
    {
      id: 'demo-home-11',
      zip: '43016',
      beds: 2,
      city: 'Riverside',
      sqft: 1010,
      baths: 2.0,
      price: 179900.0,
      state: 'OH',
      address: '305 Laurel Park Ave #4',
      image_url: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?w=800&h=600&fit=crop',
      saves_count: 38,
      views_count: 820,
      portal_saves: 38,
      portal_views: 820,
      report_saves: 30,
      report_views: 640,
      days_on_zillow: 28,
      listing_status: 'For Sale',
      showings_count: 2,
      agent_photo_url: null,
      custom_agent_name: 'Sarah Mitchell',
    },
    {
      id: 'demo-home-12',
      zip: '43081',
      beds: 3,
      city: 'Lakeview',
      sqft: 1300,
      baths: 3.0,
      price: 298000.0,
      state: 'OH',
      address: '1855 Clearwater Blvd',
      image_url: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?w=800&h=600&fit=crop',
      saves_count: 110,
      views_count: 1580,
      portal_saves: 110,
      portal_views: 1580,
      report_saves: 88,
      report_views: 1200,
      days_on_zillow: 5,
      listing_status: 'For Sale',
      showings_count: 9,
      agent_photo_url: null,
      custom_agent_name: 'James Chen',
    },
  ],
  stats: {
    avg_dom: 42,
    avg_price: 372800,
    total_sold: 0,
    total_saves: 1075,
    total_views: 23570,
    highest_sale: 950000.0,
    total_active: 12,
    total_volume: 5012600.0,
    last_year_sold: 0,
    total_listings: 12,
    total_showings: 0,
    total_homes_saves: 45,
    total_homes_views: 3150,
    total_portal_saves: 1075,
    total_portal_views: 23570,
    total_redfin_saves: 28,
    total_redfin_views: 580,
    total_report_saves: 890,
    total_report_views: 16000,
    total_trulia_saves: 12,
    total_trulia_views: 240,
    total_zillow_saves: 890,
    total_zillow_views: 16200,
    total_realtor_saves: 100,
    total_realtor_views: 3400,
  },
  market: {
    avg_demand_rating: 7.2,
    market_median_dom: 48,
    market_sold_listings: 1620,
    market_active_listings: 1480,
    neighborhoods_with_data: 14,
    team_price_reduction_rate: 18,
    market_price_reduction_rate: 34,
  },
  showings: [
    { scheduled_date: '2026-02-15T14:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-15T11:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-14T16:30:00+00:00', event_type: 'showing', attendees_count: 3 },
    { scheduled_date: '2026-02-14T13:00:00+00:00', event_type: 'open_house', attendees_count: 12 },
    { scheduled_date: '2026-02-13T15:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-13T10:30:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-12T14:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-12T11:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-11T16:00:00+00:00', event_type: 'showing', attendees_count: 4 },
    { scheduled_date: '2026-02-11T13:00:00+00:00', event_type: 'open_house', attendees_count: 18 },
    { scheduled_date: '2026-02-10T15:30:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-10T10:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-09T14:00:00+00:00', event_type: 'showing', attendees_count: 3 },
    { scheduled_date: '2026-02-09T11:30:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-08T16:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-08T13:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-07T14:30:00+00:00', event_type: 'open_house', attendees_count: 15 },
    { scheduled_date: '2026-02-07T10:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-06T15:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-06T11:00:00+00:00', event_type: 'showing', attendees_count: 3 },
    { scheduled_date: '2026-02-05T14:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-05T10:30:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-04T16:00:00+00:00', event_type: 'showing', attendees_count: 4 },
    { scheduled_date: '2026-02-04T13:00:00+00:00', event_type: 'open_house', attendees_count: 22 },
    { scheduled_date: '2026-02-03T15:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-03T10:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-02T14:30:00+00:00', event_type: 'showing', attendees_count: 3 },
    { scheduled_date: '2026-02-02T11:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-02-01T15:30:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-02-01T12:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-01-31T14:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-01-31T10:30:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-01-30T16:00:00+00:00', event_type: 'showing', attendees_count: 3 },
    { scheduled_date: '2026-01-30T13:00:00+00:00', event_type: 'open_house', attendees_count: 16 },
    { scheduled_date: '2026-01-29T14:30:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-01-29T11:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-01-28T15:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-01-28T10:00:00+00:00', event_type: 'showing', attendees_count: 4 },
    { scheduled_date: '2026-01-27T14:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-01-27T11:30:00+00:00', event_type: 'open_house', attendees_count: 14 },
    { scheduled_date: '2026-01-26T16:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-01-26T13:00:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-01-25T15:00:00+00:00', event_type: 'showing', attendees_count: 3 },
    { scheduled_date: '2026-01-25T10:30:00+00:00', event_type: 'showing', attendees_count: 0 },
    { scheduled_date: '2026-01-24T14:00:00+00:00', event_type: 'showing', attendees_count: 2 },
    { scheduled_date: '2026-01-24T11:00:00+00:00', event_type: 'showing', attendees_count: 0 },
  ],
  reviews: [
    {
      rating: 5.0,
      review_date: '2026-01-18T10:30:00',
      review_text: 'Sarah made the entire home-buying process so easy. She was always available to answer questions and went above and beyond to find us the perfect home. Could not recommend her enough!',
      reviewer_name: 'happyhomeowner22',
      reviewer_badge: 'Bought a Single Family home in 2026 in Riverside, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-12-15T08:00:00',
      review_text: 'James is incredibly knowledgeable about the local market. He helped us sell our home in just 5 days, well above asking price. His negotiation skills are top-notch.',
      reviewer_name: 'lakesideliving',
      reviewer_badge: 'Sold a Single Family home in 2025 in Lakeview, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-11-20T14:15:00',
      review_text: 'Working with Maria was an absolute pleasure. She was patient through the entire process, especially as first-time buyers. She walked us through every step and made sure we understood everything.',
      reviewer_name: 'firsttimebuyers',
      reviewer_badge: 'Bought a Single Family home in 2025 in Oakdale, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-10-28T09:45:00',
      review_text: 'David helped us find our dream home in Summit Hills. His attention to detail and understanding of what we were looking for made all the difference. We felt like his only client.',
      reviewer_name: 'summitfamily',
      reviewer_badge: 'Bought a Single Family home in 2025 in Summit Hills, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-09-14T16:00:00',
      review_text: 'Emily is fantastic! She sold our condo quickly and found us a beautiful new home, all within our timeline. Her energy and professionalism are unmatched.',
      reviewer_name: 'movingup2025',
      reviewer_badge: 'Bought and sold a home in 2025 in Brookhaven, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-08-22T11:30:00',
      review_text: 'The Horizon team is the real deal. They handled everything from staging to closing with expertise. We have used them for three transactions now and would never go anywhere else.',
      reviewer_name: 'loyalclient',
      reviewer_badge: 'Sold a Single Family home in 2025.',
    },
    {
      rating: 5.0,
      review_date: '2025-07-10T13:00:00',
      review_text: 'James was so responsive throughout the entire selling process. He provided excellent market analysis and priced our home perfectly. Sold in under two weeks!',
      reviewer_name: 'quicksale',
      reviewer_badge: 'Sold a Single Family home in 2025 in Riverside, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-06-05T09:00:00',
      review_text: 'Maria went above and beyond to help us find a home in a competitive market. Her knowledge of the neighborhoods and school districts was invaluable. Highly recommend!',
      reviewer_name: 'familyoffour',
      reviewer_badge: 'Bought a Single Family home in 2025 in Oakdale, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-05-18T15:30:00',
      review_text: 'David is a true professional. He managed our relocation from out of state seamlessly, handling everything remotely until we could visit in person. Five stars all the way.',
      reviewer_name: 'relocating2025',
      reviewer_badge: 'Bought a Single Family home in 2025 in Summit Hills, OH.',
    },
    {
      rating: 5.0,
      review_date: '2025-04-02T10:00:00',
      review_text: 'We could not have asked for a better experience. Emily was our advocate from start to finish. She negotiated a great deal for us and made closing day stress-free.',
      reviewer_name: 'newbeginnings',
      reviewer_badge: 'Bought a Single Family home in 2025 in Lakeview, OH.',
    },
  ],
  sold_listings: [
    { street_address: '608 Lakeshore Ct', city: 'Riverside', state: 'OH', zip: '43016', latitude: 40.10, longitude: -83.15, price: '$290,000', sold_date: '2/6/2026', bedrooms: 3, bathrooms: 2, living_area: 1650, represented: 'Seller', image_url: null },
    { street_address: '215 Meadowview Dr', city: 'Lakeview', state: 'OH', zip: '43081', latitude: 40.08, longitude: -82.88, price: '$342,000', sold_date: '2/4/2026', bedrooms: 4, bathrooms: 3, living_area: 2100, represented: 'Seller', image_url: null },
    { street_address: '1492 Orchard Hill Rd', city: 'Oakdale', state: 'OH', zip: '43065', latitude: 40.17, longitude: -83.07, price: '$265,000', sold_date: '2/1/2026', bedrooms: 3, bathrooms: 2, living_area: 1480, represented: 'Buyer', image_url: null },
    { street_address: '3380 Ridgetop Blvd', city: 'Summit Hills', state: 'OH', zip: '43017', latitude: 40.12, longitude: -83.12, price: '$725,000', sold_date: '1/28/2026', bedrooms: 5, bathrooms: 4, living_area: 3400, represented: 'Seller', image_url: null },
    { street_address: '912 Elm Crossing', city: 'Brookhaven', state: 'OH', zip: '43230', latitude: 40.02, longitude: -82.87, price: '$198,500', sold_date: '1/25/2026', bedrooms: 2, bathrooms: 2, living_area: 1100, represented: 'Buyer', image_url: null },
    { street_address: '4701 Stone Bridge Way', city: 'Riverside', state: 'OH', zip: '43016', latitude: 40.06, longitude: -83.18, price: '$415,000', sold_date: '1/20/2026', bedrooms: 4, bathrooms: 3, living_area: 2300, represented: 'Seller', image_url: null },
    { street_address: '2288 Whispering Pines', city: 'Lakeview', state: 'OH', zip: '43082', latitude: 40.13, longitude: -82.92, price: '$380,000', sold_date: '1/15/2026', bedrooms: 4, bathrooms: 3, living_area: 2050, represented: 'Seller', image_url: null },
    { street_address: '567 Magnolia Ct', city: 'Oakdale', state: 'OH', zip: '43065', latitude: 40.15, longitude: -83.02, price: '$310,000', sold_date: '1/10/2026', bedrooms: 3, bathrooms: 2, living_area: 1720, represented: 'Buyer', image_url: null },
    { street_address: '8100 Copper Ridge Ln', city: 'Summit Hills', state: 'OH', zip: '43017', latitude: 40.09, longitude: -83.10, price: '$1,150,000', sold_date: '1/5/2026', bedrooms: 6, bathrooms: 5, living_area: 4800, represented: 'Seller', image_url: null },
    { street_address: '1045 Aspen Grove Dr', city: 'Brookhaven', state: 'OH', zip: '43230', latitude: 39.97, longitude: -82.84, price: '$225,000', sold_date: '12/28/2025', bedrooms: 3, bathrooms: 2, living_area: 1350, represented: 'Buyer', image_url: null },
    { street_address: '3920 Heritage Oak Blvd', city: 'Riverside', state: 'OH', zip: '43016', latitude: 40.04, longitude: -83.14, price: '$475,000', sold_date: '12/20/2025', bedrooms: 4, bathrooms: 3, living_area: 2650, represented: 'Seller', image_url: null },
    { street_address: '741 Ivy Lane', city: 'Lakeview', state: 'OH', zip: '43081', latitude: 40.11, longitude: -82.90, price: '$268,000', sold_date: '12/15/2025', bedrooms: 3, bathrooms: 2, living_area: 1500, represented: 'Buyer', image_url: null },
    { street_address: '1560 Valley Stream Rd', city: 'Oakdale', state: 'OH', zip: '43065', latitude: 40.18, longitude: -83.05, price: '$295,000', sold_date: '12/10/2025', bedrooms: 3, bathrooms: 2, living_area: 1680, represented: 'Seller', image_url: null },
    { street_address: '5230 Summit View Ter', city: 'Summit Hills', state: 'OH', zip: '43017', latitude: 40.07, longitude: -83.16, price: '$895,000', sold_date: '12/5/2025', bedrooms: 5, bathrooms: 4, living_area: 3900, represented: 'Seller', image_url: null },
    { street_address: '882 Foxwood Chase', city: 'Brookhaven', state: 'OH', zip: '43230', latitude: 40.00, longitude: -82.86, price: '$340,000', sold_date: '11/28/2025', bedrooms: 4, bathrooms: 3, living_area: 1900, represented: 'Buyer', image_url: null },
    { street_address: '2015 Cobblestone Path', city: 'Riverside', state: 'OH', zip: '43016', latitude: 40.08, longitude: -83.20, price: '$355,000', sold_date: '11/22/2025', bedrooms: 3, bathrooms: 2, living_area: 1800, represented: 'Seller', image_url: null },
    { street_address: '3340 Autumn Ridge Dr', city: 'Lakeview', state: 'OH', zip: '43082', latitude: 40.14, longitude: -82.94, price: '$420,000', sold_date: '11/15/2025', bedrooms: 4, bathrooms: 3, living_area: 2400, represented: 'Seller', image_url: null },
    { street_address: '695 Cedar Brook Way', city: 'Oakdale', state: 'OH', zip: '43065', latitude: 40.16, longitude: -83.00, price: '$185,000', sold_date: '11/8/2025', bedrooms: 2, bathrooms: 1, living_area: 980, represented: 'Buyer', image_url: null },
    { street_address: '4480 Crestwood Dr', city: 'Summit Hills', state: 'OH', zip: '43017', latitude: 40.11, longitude: -83.08, price: '$580,000', sold_date: '11/1/2025', bedrooms: 4, bathrooms: 3, living_area: 2800, represented: 'Seller', image_url: null },
    { street_address: '1120 Willow Glen Ct', city: 'Brookhaven', state: 'OH', zip: '43230', latitude: 39.98, longitude: -82.82, price: '$245,000', sold_date: '10/25/2025', bedrooms: 3, bathrooms: 2, living_area: 1400, represented: 'Buyer', image_url: null },
    { street_address: '2780 Sunstone Cir', city: 'Riverside', state: 'OH', zip: '43016', latitude: 40.05, longitude: -83.11, price: '$510,000', sold_date: '10/18/2025', bedrooms: 5, bathrooms: 3, living_area: 2900, represented: 'Seller', image_url: null },
    { street_address: '450 Bayberry Ln', city: 'Lakeview', state: 'OH', zip: '43081', latitude: 40.09, longitude: -82.89, price: '$278,000', sold_date: '10/10/2025', bedrooms: 3, bathrooms: 2, living_area: 1550, represented: 'Buyer', image_url: null },
    { street_address: '1875 Rolling Hills Rd', city: 'Oakdale', state: 'OH', zip: '43065', latitude: 40.19, longitude: -83.04, price: '$325,000', sold_date: '10/2/2025', bedrooms: 3, bathrooms: 2, living_area: 1750, represented: 'Seller', image_url: null },
    { street_address: '6250 Eagle Point Dr', city: 'Summit Hills', state: 'OH', zip: '43017', latitude: 40.10, longitude: -83.13, price: '$1,350,000', sold_date: '9/25/2025', bedrooms: 6, bathrooms: 6, living_area: 5200, represented: 'Seller', image_url: null },
    { street_address: '330 Clover Field Way', city: 'Brookhaven', state: 'OH', zip: '43230', latitude: 39.99, longitude: -82.85, price: '$215,000', sold_date: '9/18/2025', bedrooms: 2, bathrooms: 2, living_area: 1200, represented: 'Buyer', image_url: null },
  ],
  view_sources: {
    homes: 3150,
    redfin: 580,
    zillow: 16200,
    trulia: 240,
    realtor: 3400,
    youtube: 820,
    facebook: 24500,
    instagram: 18200,
  },
} as const;
